"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Redirect_OnDamageAbsorbedEventHandlerScript = void 0;
const __1 = require("../..");
const Damage_1 = require("../../core/Damage");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Redirect_OnDamageAbsorbedEventHandlerScript = class Effect_Redirect_OnDamageAbsorbedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.DamageAbsorbed) {
            return;
        }
        const aliveActors = [];
        for (const target of handler.args.scriptArgs.redirectTo) {
            if (!container.isDeceased(target)) {
                continue;
            }
            aliveActors.push(target);
        }
        let damagePerActor = event.args.damageAbsorbed.amount / aliveActors.length;
        for (const actor of aliveActors) {
            const health = container.getAttributeScore(actor, __1.AttributeType.Health);
            container.applyExactDamage({
                sequence,
                attackerId: event.subject,
                targetId: actor,
                damage: new Damage_1.Damage(event.args.damageAbsorbed.type, Math.min(health, damagePerActor))
            });
        }
    }
};
Effect_Redirect_OnDamageAbsorbedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Redirect_OnDamageAbsorbed")
], Effect_Redirect_OnDamageAbsorbedEventHandlerScript);
exports.Effect_Redirect_OnDamageAbsorbedEventHandlerScript = Effect_Redirect_OnDamageAbsorbedEventHandlerScript;
